import * as hoc from './hoc';
import { CheckboxShallow } from '../Checkbox';

export const Toggle = hoc.withToggle(CheckboxShallow);
